import { createAction, props } from '@ngrx/store';
import { Certification } from '../_models/certification';

// Action types
export const loadCertifications = createAction('[Certification] Load Certifications');
export const loadCertificationsSuccess = createAction(
  '[Certification] Load Certifications Success',
  props<{ certifications: Certification[] }>()
);
export const loadCertificationsFailure = createAction(
  '[Certification] Load Certifications Failure',
  props<{ error: any }>()
);

export const addCertification = createAction(
  '[Certification] Add Certification',
  props<{ certification: Certification }>()
);
export const addCertificationSuccess = createAction(
  '[Certification] Add Certification Success',
  props<{ certification: Certification }>()
);
export const addCertificationFailure = createAction(
  '[Certification] Add Certification Failure',
  props<{ error: any }>()
);

export const updateCertification = createAction(
  '[Certification] Update Certification',
  props<{ certification: Certification }>()
);
export const updateCertificationSuccess = createAction(
  '[Certification] Update Certification Success',
  props<{ certification: Certification }>()
);
export const updateCertificationFailure = createAction(
  '[Certification] Update Certification Failure',
  props<{ error: any }>()
);

export const deleteCertification = createAction(
  '[Certification] Delete Certification',
  props<{ id: number }>()
);
export const deleteCertificationSuccess = createAction(
  '[Certification] Delete Certification Success',
  props<{ id: number }>()
);
export const deleteCertificationFailure = createAction(
  '[Certification] Delete Certification Failure',
  props<{ error: any }>()
);
